<!-- <p>invoice-module works!</p> -->
<div class="modal fade" *ngIf="showModal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">View</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body" style="overflow: hidden;">


        <div class="container">
          <table class="styled-table">
            <tbody>
              <tr>
               
                <td>
                  <span style="display:flex;">
                    <span class="fw-bold">Name:&nbsp;</span>
                    <span  class="text-primary">{{finalinvoiceres?.customer?.firstName}}&nbsp;&nbsp;{{finalinvoiceres?.customer?.lastName}}</span>
                  </span>
                </td>

                
                <td>
  <div style="display: grid; grid-template-columns: auto 1fr; column-gap: 4px;">
    <span class="fw-bold">Invoice Number:</span>
    <span class="text-primary">{{ finalinvoiceres?.invoiceNumber }}</span>
  </div>
</td>

 
<td>
  <div style="display: grid; grid-template-columns: auto 1fr; column-gap: 4px;">
    <span class="fw-bold">IGBMS ID:</span>
    <div class="text-primary" style="word-break: break-word;">
       {{ finalinvoiceres?.fusebillCustomerId }}
    </div>
  </div>
</td>



              </tr>
              <tr>
                <td><span class="fw-bold">Status:&nbsp;<span
                      class="text-primary">{{getInvoiceStatus(finalinvoiceres?.status)}}</span></span></td>
                <td>
                  <span class="fw-bold">Month:&nbsp;<span class="text-primary">{{finalinvoiceres?.invoiceDate |
                      date:'MMM-yyyy'}}</span></span>
                </td>
              </tr>
            
            </tbody>
          </table>

          <!-- Scrollable PDF Viewer Section -->
          <div class="scrollable">
            <pdf-viewer *ngIf="invoiceLink" id="pdf-viewer" [src]="invoiceLink" [render-text]="true"
              [original-size]="false" style="height: 90vh; width: 100%;"></pdf-viewer>
          </div>


        </div>


      </div>

      <div class="modal-footer">

        <div *ngFor="let button of actionButtons">
          <button type="button" class="btn btn-primary" id="closeaddadmin" *ngIf="button.condition"
            [style.backgroundColor]="button.backgroundColor" (click)="button.onClick()">
            <i [class]="button.icon" aria-hidden="true"></i>&nbsp;&nbsp; {{ button.label }}
          </button>
        </div>
        <button type="button" class="btn btn-primary" (click)="DownloadInvoice(invoiceLink)">
          <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Download
        </button>
      </div>
    </div>
  </div>
</div>